import saveAs from "file-saver";

export class TcmFileBlobResponse {

    private name: string;
    private blob: string;

    constructor(name: string, blob: any) {

        this.name = name;
        this.blob = blob;
    }
    
    toBlobAsync() {
        return Promise.resolve(this.blob);
    }

    save() {
        saveAs(this.blob, this.name.replace(new RegExp('"', 'g'), ''));
    }
}